import type { ReactNode } from 'react';
import { styled } from '@mui/material/styles';

type GlassCardProps = {
  children: ReactNode;
};

const GlassCardRoot = styled('div')(({ theme }) => ({
  marginTop: '3rem',
  marginBottom: '3rem',
  width: '100%',
  maxWidth: '717px',
  minHeight: 'auto',
  padding: '40px 17px',
  alignSelf: 'center',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '31px',
  background:
    'linear-gradient(180deg, rgba(56, 56, 56, 0.6) 0%, rgba(0, 0, 0, 0.6) 100%)',
  backdropFilter: 'blur(11.65px)',
  WebkitBackdropFilter: 'blur(11.65px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxSizing: 'border-box',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    padding: '32px 20px',
  },
}));

const GlassCard = ({ children }: GlassCardProps) => (
  <GlassCardRoot>{children}</GlassCardRoot>
);

export default GlassCard;
